import _ from "lodash";

export default {
  props: {
    value: Object,
    btnText: String,
    submit: Function,
  },
  data() {
    const year = new Date().getFullYear();
    return {
      form: { ...this.value },
      years: _.range(year + 7, year - 100),
    };
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.form = { ...this.value };
      },
    },
    form: {
      deep: true,
      handler() {
        if (JSON.stringify(this.form) != JSON.stringify(this.value)) {
          this.$emit("input", this.form);
        }
      },
    },
  },
};
